// import logo from './logo.svg';
import MainRoutes from "./routes/MainRoutes";
import "./App.css";

function App() {
  return (
    <div className="App">
      <MainRoutes />
     
    </div>
  );
}

export default App;
